// 共有ロガーの再エクスポート（実体は @new-cti/frontend-shared）。
export { logger } from '@new-cti/frontend-shared/auth/logger';
